<div class="page-content" *ngIf="theme$ | async as theme" [ngClass]="theme">
  <router-outlet></router-outlet>
</div>
